<template>
  <div v-if="property">
    <router-link v-if="hasRoleToRead" :to="route">{{ property.label }}</router-link>
    <span v-if="!hasRoleToRead">{{ property.label }}</span>
  </div>
</template>

<script>
import entities from "@/entities/entities";

export default {
  name: "app-entity-link",

  props: {
    entityName: String,
    property: Object
  },

  computed: {
    entity() {
      return entities.get(this.entityName);
    },

    hasRoleToRead() {
      return this.$store.getters[
        `entities/${this.entity.name.singular}/hasRoleToRead`
      ];
    },

    route() {
      return {
        name: `${this.entity.name.singular}Show`,
        params: { id: this.property.id }
      };
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/entity-link.vue?1cffe79e